/* eslint-disable no-useless-concat */
import PopupBodyItem from "../../Helpers/Popup/PopupParts/PopupBodyItem";
import { useListAllDriversQuery } from "../../../Redux/service/Drivers/Drivers";
import trans from "../../../utils";
import { useGetSpecificGroupQuery } from "../../../Redux/service/Groups/Groups";
import { DistanceUnit, VolumeUniit } from "../../../JsHelpers/PlatformUnits";
import { useSelector } from "react-redux";

export default function VehicleDetails({ values = {} }) {
	const getValue = (value, defaultValue = "-----") =>
		value ? trans(value) : defaultValue;

	const {
		name = "",
		code = "",
		plateNumber = "",
		fuelType = "",
		idleAlert = "",
		vin = "",
		simNumber = "",
		simNumberSerial = "",
		make = "",
		model = "",
		year = "",
		fuelCapacity = "",
		tankLength = "",
		tankHeight = "",
		tankWidth = "",
		vehicleType = "",
		driverId = "",
		registrationNumber = "",
		odometer = "",
		fuelSupport = "",
		fuelCost = "",
		fuelConsumption = "",
		idleTime = "",
		archived = "",
		imei = "",
		vehicleExpires = "",
		licenseExpire = "",
		licenseExpireReminder,
		brand = "",
		color = "",
		groupId = "",
		deviceType = "",
	} = values;
	const inf = useSelector((state) => state.users.user);
	const { data: driversData = [] } = useListAllDriversQuery();
	const { data: GroupDetails } = useGetSpecificGroupQuery(groupId, {
		skip: !groupId,
	});
	const selectedDriver = driversData.find((driver) => driver.id === driverId);
	const formatIdleTime = (time) =>
		time ? `${time} Minute${time > 1 ? "s" : ""}` : "-----";
	const getOnOffStatus = (status) => (status === true ? "ON" : "OFF");
	const getFMSStatus = (status) => (status === true ? "Archived" : "Active");
	return (
		<>
			<p className="fs-16 fw-700 brand-700 text-uppercase">
				{trans("Vehicle Details")}
			</p>
			<div className="row">
				<div className="col-lg-6">
					<div className="display-border">
						<PopupBodyItem title={trans("Name")} item={getValue(name)} />
						<PopupBodyItem title={trans("Code")} item={getValue(code)} />{" "}
						<PopupBodyItem
							title={trans("plate number")}
							item={getValue(plateNumber)}
						/>
						<PopupBodyItem
							title={trans("Vehicle type")}
							item={getValue(vehicleType)}
						/>
						<PopupBodyItem title={trans("Make")} item={getValue(make)} />
						<PopupBodyItem title={trans("Model")} item={getValue(model)} />{" "}
						<PopupBodyItem title={trans("Brand")} item={getValue(brand)} />
						<PopupBodyItem title={trans("Year")} item={getValue(year)} />
						<PopupBodyItem title={trans("color")} item={getValue(color)} />
						<PopupBodyItem
							title={trans("group")}
							item={getValue(GroupDetails?.name)}
						/>
						<PopupBodyItem
							title={trans("Fuel Type")}
							item={getValue(fuelType)}
						/>
						<PopupBodyItem
							title={trans("Fuel Capacity")}
							item={getValue(
								VolumeUniit(fuelCapacity, inf.attributes.volumeUnit || "ltr"),
							)}
						/>
						<PopupBodyItem
							title={trans("Fuel Consumption")}
							item={getValue(
								VolumeUniit(
									fuelConsumption,
									inf.attributes.volumeUnit || "ltr",
								),
							)}
						/>
						<PopupBodyItem
							title={trans("Fuel Cost")}
							item={getValue(fuelCost) + " " + "AED"}
						/>
						<PopupBodyItem
							title={trans("Fuel support")}
							item={getOnOffStatus(fuelSupport)}
						/>
						<PopupBodyItem
							title={trans("Tank Height")}
							item={getValue(tankHeight)}
						/>
					</div>
				</div>
				<div className="col-lg-6">
					<div className="display-border">
						<PopupBodyItem
							title={trans("Tank Width")}
							item={getValue(tankWidth)}
						/>
						<PopupBodyItem
							title={trans("Tank Length")}
							item={getValue(tankLength)}
						/>
						<PopupBodyItem
							title={trans("Device Type")}
							item={getValue(deviceType)}
						/>
						<PopupBodyItem title={trans("IMEI")} item={getValue(imei)} />
						<PopupBodyItem
							title={trans("SIM Number")}
							item={`+${getValue(simNumber)}`}
						/>
						<PopupBodyItem
							title={trans("SIM Number Serial")}
							item={`${getValue(simNumberSerial)}`}
						/>
						<PopupBodyItem title={trans("VIN")} item={getValue(vin)} />
						<PopupBodyItem
							title={trans("Registration number")}
							item={getValue(registrationNumber)}
						/>
						<PopupBodyItem
							title={trans("Vehicle Expiration")}
							item={getValue(vehicleExpires)}
						/>
						<PopupBodyItem
							title={trans("License Expire")}
							item={getValue(licenseExpire)}
						/>
						<PopupBodyItem
							title={trans("Liscense Expiration Reminder")}
							item={getOnOffStatus(licenseExpireReminder)}
						/>
						<PopupBodyItem
							title={trans("FMS Status")}
							item={getFMSStatus(archived)}
						/>{" "}
						<PopupBodyItem
							title={trans("Odometer")}
							item={DistanceUnit(odometer, inf.attributes.distanceUnit || "km")}
						/>
						<PopupBodyItem
							title={trans("Idle time")}
							item={formatIdleTime(idleTime)}
						/>
						<PopupBodyItem
							title={trans("Idle Alert")}
							item={getOnOffStatus(idleAlert)}
						/>
						<PopupBodyItem
							title={trans("Assigned Driver")}
							item={getValue(selectedDriver?.name)}
						/>
					</div>
				</div>
			</div>
		</>
	);
}
